import { REGEXP_ONLY_DIGITS } from "input-otp"

import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@/components/ui/input-otp"

function normalizeOtp(value) {
  return value.replace(/\D/g, "").slice(0, 6)
}

export function SixDigitOtpInput({
  id,
  ariaLabel,
  value,
  onChange,
  containerClassName = "justify-center",
  textAlign = "center",
  ref,
}) {
  return (
    <InputOTP
      id={id}
      aria-label={ariaLabel}
      ref={ref}
      value={value}
      onChange={(nextValue) => onChange(normalizeOtp(nextValue))}
      maxLength={6}
      pattern={REGEXP_ONLY_DIGITS}
      pushPasswordManagerStrategy="none"
      textAlign={textAlign}
      containerClassName={containerClassName}
    >
      <InputOTPGroup>
        <InputOTPSlot index={0} />
        <InputOTPSlot index={1} />
        <InputOTPSlot index={2} />
      </InputOTPGroup>
      <InputOTPSeparator />
      <InputOTPGroup>
        <InputOTPSlot index={3} />
        <InputOTPSlot index={4} />
        <InputOTPSlot index={5} />
      </InputOTPGroup>
    </InputOTP>
  )
}
